import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as messageActions from '../../../modules/message';
import { nl2br, nl2brElement } from '../../../utils/utils';
import { APP_CONFIG } from '../../../utils/config';
import * as configAction from '../../../modules/config';

import Flicking from '@egjs/react-flicking';
/*
import '@egjs/react-flicking/dist/flicking.css';
// Or, if you have to support IE9
import '@egjs/react-flicking/dist/flicking-inline.css';
*/
//import sc from 'styled-components';
class Admission_greet extends PureComponent {
	constructor(props) {
		super(props);
	}

	clickMessage(value) {
		console.log(value);
		let sendData = {
			utterance: value,
			sessionKey: this.props.message.sessionKey,
			channelId: this.props.message.channelId,
			isLogin: this.props.message.isLogin,
			isDev: this.props.config.isDev,
			blockId: '',
			projectId: this.props.config.projectId,
		};
		//console.log(sendData);
		this.props.send(sendData);
	}

	/*clickProject(a) {
		this.props.setProject(a);
		this.props.projectId = a;
		this.props.get(this.props);
		console.log(this.props);
	}*/

	//changeProject 로직(프로젝트아이디가 현재와 targetprojectId가 같을경우 세션키 갱신 안하도록 설정)
	clickProject(projectId, utterance) {
		var param = JSON.parse(JSON.stringify(this.props));
		if(this.props.config.projectId !== projectId){
			param.message.sessionKey = undefined;
		}
		param.projectId = projectId;
		param.utterance = utterance;
		this.props.setProject(projectId);
		this.props.get(param);
		
	}

	render() {
		return (
			
			<div className="bot_wrap">
				<span className="ico_comm ico_chatbot"></span>
				<span className="bot_name">{this.props.uiTexts.text_00}</span>
				<div className="bot_flex">
					
					<div className="bot_box">
						
						<div className="bot_txt main" >
							<div style={{textAlign : "center"}}>
								<img src="/contents_image/greeting.png" style={{width : "100px", height : "126px"}}/>
							</div>
							{nl2brElement(this.props.pharses)}
							<div className="btn_group">
								<a className="btn_link greet" onClick={() => this.clickProject("17", "수시")} style={{width : "49.5%", display : 'inline-block'}}><img src="http://answerny.ai/chatbot/projects/ewha/image/image_Swipebtn13.png"/>수시전형</a>
								{/*<a className="btn_link greet" href={"https://chat.ewha.ac.kr/upload/24ED_EWHA_44.pdf"} style={{width : "49.5%", display : 'inline-block', float : "right"}}><img src="http://answerny.ai/chatbot/projects/ewha/image/image_Swipebtn14.png"/>정시전형</a>*/}
								<a className="btn_link greet" onClick={() => this.clickProject("18", "정시")} style={{width : "49.5%", display : 'inline-block', float : "right"}}><img src="http://answerny.ai/chatbot/projects/ewha/image/image_Swipebtn14.png"/>정시전형</a>
							</div>
							
						</div>
					</div>
				</div>
			</div>
			
		);
		
	}
}

function mapStateToProps(state) {
	return { ...state };
}

function mapDispatchToProps(dispatch) {
	return {
		send: (payload) => dispatch(messageActions.sendMessage(payload)),
		get: (payload) => dispatch(messageActions.getGreeting(payload)),
		setProject: (payload) => dispatch(configAction.setProject(payload)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Admission_greet);
